import { Controller } from "stimulus";
import Rails from "@rails/ujs";

let redirectUrl = "";

export default class extends Controller {
	static targets = ["checkbox"]

	agree() {
		this.checkboxTarget.disabled = true;
		setTimeout(function () {
			if (redirectUrl.length > 0) {
				window.location.replace(redirectUrl)
			}
    }, 500);
	}

	buyArtist() {
		redirectUrl = "/select_subscription?selected_plan=artist"
	}

	buyMaster() {
		redirectUrl = "/select_subscription?selected_plan=master"
	}
}
